
import { FSharpRef, Record } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { class_type, record_type, lambda_type, unit_type, option_type, string_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { IntMode, MemoryEditorData, PopupDialogData, Msg, PopupDialogData_$reflection, Msg_$reflection } from "../Model/ModelType.js";
import { uncurry3, curry3, Exception, comparePrimitives, int32ToString, uncurry2, curry2, equals } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { map as map_1, defaultArg, value as value_5 } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { concat, filter, printf, toText } from "../fable_modules/fable-library-js.5.13.0/String.js";
import * as prism from "../../../src/Renderer/VerilogComponent/prism.js";
import { Component } from "react";
import * as react_1 from "react";
import react_simple_code_editor from "react-simple-code-editor";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { fromOne, op_LeftShift, tryParse, toString, fromInt32, toInt32, fromZero } from "../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { append as append_1, map, empty as empty_1, singleton, collect, delay, toList } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.13.0/Range.js";
import { HighLightColor, NumberBase as NumberBase_1, InitMemData } from "../Common/CommonTypes.js";
import { Card_body, Card_card, background, Option, modal, Card_foot, Card_title, Card_head } from "../fable_modules/Fulma.3.0.0/Components/Modal.fs.js";
import { mapIndexed2, max, map2, initialize, getSlice, length, append, ofArray, empty, singleton as singleton_1 } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { FlexDirection_Option, Color_IColor, Common_GenericOption } from "../fable_modules/Fulma.3.0.0/Common.fs.js";
import { HTMLAttr, CSSProp, DOMAttr } from "../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { Option as Option_1, delete$ } from "../fable_modules/Fulma.3.0.0/Elements/Delete.fs.js";
import { Option as Option_2, progress } from "../fable_modules/Fulma.3.0.0/Elements/Progress.fs.js";
import { item, right, left, Level_Option, level } from "../fable_modules/Fulma.3.0.0/Layouts/Level.fs.js";
import { Option as Option_3, button } from "../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { StringModule_Length, StringModule_StartsWithLetter } from "../Common/EEExtensions.js";
import { input } from "../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { Option as Option_4, IInputType } from "../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { getBigintEventValue, getIntEventValue, getTextEventValue } from "../Interface/JSHelpers.js";
import { getErrorTable, getLineCounterDiv, infoHoverableElement } from "../VerilogComponent/CodeEditorHelpers.js";
import { Option as Option_5, label } from "../fable_modules/Fulma.3.0.0/Elements/Form/Label.fs.js";
import { isMatch } from "../fable_modules/fable-library-js.5.13.0/RegExp.js";
import { isReservedParamName, isValidParamName } from "../Common/ParameterTypes.js";
import "../../../src/Renderer/VerilogComponent/prism.css";
import "prismjs/components/prism-clike";

export const Constants_infoSignUnicode = "🛈";



export class CERSCProps extends Record {
    constructor(CurrentCode, ReplaceCode, Dispatch, DialogData, Compile) {
        super();
        this.CurrentCode = CurrentCode;
        this.ReplaceCode = ReplaceCode;
        this.Dispatch = Dispatch;
        this.DialogData = DialogData;
        this.Compile = Compile;
    }
}

export function CERSCProps_$reflection() {
    return record_type("PopupHelpers.CERSCProps", [], CERSCProps, () => [["CurrentCode", string_type], ["ReplaceCode", option_type(string_type)], ["Dispatch", lambda_type(Msg_$reflection(), unit_type)], ["DialogData", PopupDialogData_$reflection()], ["Compile", lambda_type(PopupDialogData_$reflection(), unit_type)]]);
}

export class CERSCState extends Record {
    constructor(code) {
        super();
        this.code = code;
    }
}

export function CERSCState_$reflection() {
    return record_type("PopupHelpers.CERSCState", [], CERSCState, () => [["code", string_type]]);
}

export const verilogEditorTemplate = "module NAME(\n  // Write your IO Port Declarations here\n  \n);  \n  // Write your Assignments here\n  \n  \n  \nendmodule";

export class CodeEditorReactStatefulComponent extends Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = (new CERSCState(verilogEditorTemplate));
    }
    componentDidUpdate(prevProps, prevState) {
        let bind$0040;
        const this$ = this;
        if (!equals(this$.props.ReplaceCode, undefined) && equals(prevProps.ReplaceCode, undefined)) {
            this$.setState((s, _arg) => (new CERSCState(value_5(this$.props.ReplaceCode))));
            this$.props.Dispatch(new Msg(/* SetPopupDialogCode */ 55, [this$.props.ReplaceCode]));
            this$.props.Compile((bind$0040 = this$.props.DialogData, new PopupDialogData(bind$0040.Text, bind$0040.Text2, bind$0040.Int, bind$0040.ImportDecisions, bind$0040.Int2, bind$0040.Int3, bind$0040.ProjectPath, bind$0040.MemorySetup, bind$0040.MemoryEditorData, bind$0040.Progress, bind$0040.ConstraintTypeSel, bind$0040.ConstraintIOSel, bind$0040.ConstraintErrorMsg, bind$0040.NewConstraint, bind$0040.AlgebraInputs, bind$0040.AlgebraError, this$.props.ReplaceCode, bind$0040.VerilogErrors, bind$0040.BadLabel, bind$0040.IntList, bind$0040.IntList2, bind$0040.DialogState)));
        }
    }
    componentDidMount() {
        const this$ = this;
        if (!equals(this$.props.ReplaceCode, undefined)) {
            this$.setState((s, _arg) => (new CERSCState(value_5(this$.props.ReplaceCode))));
        }
    }
    render() {
        let props_1, arg;
        const this$ = this;
        const props_2 = [["style", {
            position: "relative",
            left: "35px",
            height: "100%",
        }]];
        const children_1 = [(props_1 = {
            placeholder: "Start Writing your Verilog Code here...",
            value: (arg = (this$.state).code, toText(printf("%s"))(arg)),
            padding: 5,
            onValueChange: (txt) => {
                let bind$0040;
                this$.setState((s, p) => (new CERSCState(txt)));
                this$.props.Dispatch(new Msg(/* SetPopupDialogCode */ 55, [txt]));
                this$.props.Compile((bind$0040 = this$.props.DialogData, new PopupDialogData(bind$0040.Text, bind$0040.Text2, bind$0040.Int, bind$0040.ImportDecisions, bind$0040.Int2, bind$0040.Int3, bind$0040.ProjectPath, bind$0040.MemorySetup, bind$0040.MemoryEditorData, bind$0040.Progress, bind$0040.ConstraintTypeSel, bind$0040.ConstraintIOSel, bind$0040.ConstraintErrorMsg, bind$0040.NewConstraint, bind$0040.AlgebraInputs, bind$0040.AlgebraError, txt, bind$0040.VerilogErrors, bind$0040.BadLabel, bind$0040.IntList, bind$0040.IntList2, bind$0040.DialogState)));
            },
            highlight: (code) => prism.highlight(code, Prism.languages.verilog),
        }, react_1.createElement(react_simple_code_editor, props_1))];
        return react_1.createElement("div", keyValueList(props_2, 1), ...children_1);
    }
}

export function CodeEditorReactStatefulComponent_$reflection() {
    return class_type("PopupHelpers.CodeEditorReactStatefulComponent", undefined, CodeEditorReactStatefulComponent, class_type("Fable.React.Component`2", [CERSCProps_$reflection(), CERSCState_$reflection()], Component));
}

export function CodeEditorReactStatefulComponent_$ctor_3A406D1E(props) {
    return new CodeEditorReactStatefulComponent(props);
}

export function openInBrowser(url, _arg) {
    window.issieBridge.openExternal(url);
}

export function preventDefault(e) {
    e.preventDefault();
}

export function getText(dialogData) {
    return defaultArg(dialogData.Text, "");
}

export function getText2(dialogData) {
    return defaultArg(dialogData.Text2, "");
}

export function getImportDecisions(dialogData) {
    return dialogData.ImportDecisions;
}

export function getCode(dialogData) {
    return defaultArg(dialogData.VerilogCode, "");
}

export function getErrorList(dialogData) {
    return dialogData.VerilogErrors;
}

export function getInt(dialogData) {
    return defaultArg(dialogData.Int, 1) | 0;
}

export function getInt2(dialogData) {
    return defaultArg(dialogData.Int2, fromZero());
}

export function getIntList(dialogData, numInputsDefault, widthDefault) {
    return defaultArg(dialogData.IntList, toList(delay(() => collect((matchValue) => singleton(widthDefault), rangeDouble(1, 1, numInputsDefault)))));
}

export function getIntList2(dialogData, numInputsDefault, lsbDefault) {
    return defaultArg(dialogData.IntList2, toList(delay(() => collect((matchValue) => singleton(lsbDefault), rangeDouble(1, 1, numInputsDefault)))));
}

export function getMemorySetup(dialogData, wordWidthDefault) {
    return defaultArg(dialogData.MemorySetup, [4, wordWidthDefault, InitMemData.FromData, undefined]);
}

export function getMemoryEditor(model) {
    return defaultArg(model.PopupDialogData.MemoryEditorData, new MemoryEditorData(false, undefined, fromZero(), NumberBase_1.Hex));
}

/**
 * Unclosable popup.
 */
export function unclosablePopup(maybeTitle, body, maybeFoot, extraStyle, dispatch) {
    let head;
    if (maybeTitle != null) {
        const title = maybeTitle;
        head = Card_head(singleton_1(new Common_GenericOption(/* Props */ 1, [singleton_1(["style", {
            userSelect: "none",
        }])])), singleton_1(Card_title(empty(), singleton_1(title))));
    }
    else {
        head = react_1.createElement("div", {});
    }
    const foot_1 = (maybeFoot != null) ? Card_foot(empty(), singleton_1(maybeFoot)) : react_1.createElement("div", {});
    return modal(singleton_1(new Option(/* IsActive */ 1, [true])), ofArray([background(empty(), empty()), Card_card(singleton_1(new Common_GenericOption(/* Props */ 1, [singleton_1(["style", keyValueList(extraStyle, 1)])])), ofArray([head, Card_body(singleton_1(new Common_GenericOption(/* Props */ 1, [singleton_1(["style", {
        userSelect: "none",
    }])])), singleton_1(body)), foot_1]))]));
}

export function noDispatch(react, _dispatch) {
    return react;
}

export function mapNoDispatch(optReact) {
    let react;
    const option = optReact;
    if (option != null) {
        return (react = option, (_dispatch) => noDispatch(react, _dispatch));
    }
    else {
        return undefined;
    }
}

export function showMemoryEditorPopup(maybeTitle, body, maybeFoot, extraStyle, dispatch) {
    return dispatch(new Msg(/* ShowPopup */ 49, [(_arg, model) => unclosablePopup(maybeTitle, body(getMemoryEditor(model)), maybeFoot, extraStyle, dispatch)]));
}

/**
 * Base popup builder function, used by other popup generators
 */
export function buildPopup(title, body, foot, close, extraStyle, dispatch, model) {
    return modal(ofArray([new Option(/* IsActive */ 1, [true]), new Option(/* CustomClass */ 2, ["modal1"]), new Option(/* Props */ 0, [singleton_1(["style", {
        zIndex: 20000,
    }])])]), ofArray([background(singleton_1(new Common_GenericOption(/* Props */ 1, [singleton_1(new DOMAttr(/* OnClick */ 40, [curry2(close)(dispatch)]))])), empty()), Card_card(singleton_1(new Common_GenericOption(/* Props */ 1, [singleton_1(["style", keyValueList(append(ofArray([new CSSProp(/* OverflowY */ 272, ["auto"]), new CSSProp(/* OverflowX */ 271, ["visible"]), new CSSProp(/* UserSelect */ 381, ["none"])]), extraStyle), 1)])])), ofArray([Card_head(empty(), ofArray([Card_title(empty(), singleton_1(title)), delete$(singleton_1(new Option_1(/* OnClick */ 3, [curry2(close)(dispatch)])), empty())])), Card_body(singleton_1(new Common_GenericOption(/* Props */ 1, [singleton_1(["style", {
        overflowY: "visible",
        overflowX: "visible",
    }])])), singleton_1(body(dispatch, model))), Card_foot(empty(), singleton_1(foot(dispatch, model)))]))]));
}

/**
 * Body and foot are functions that take a string of text and produce a
 * reactElement. The meaning of the input string to those functions is the
 * content of PopupDialogText (i.e. in a dialog popup, the string is the
 * current value of the input box.).
 */
export function dynamicClosablePopup(title, body, foot, extraStyle, dispatch) {
    dispatch(new Msg(/* ShowPopup */ 49, [(dispatch_2, model) => buildPopup(title, uncurry2((_arg) => body), uncurry2((_arg_1) => foot), (dispatch_1, _arg_2) => {
        dispatch_1(Msg.ClosePopup);
    }, extraStyle, dispatch_2, model)]));
}

/**
 * As dynamicClosablePopup but accept functions of dispatch and return the popup function
 */
export function dynamicClosablePopupFunc(title, body, foot, extraStyle) {
    return (dispatch_1) => ((model) => buildPopup(title, body, foot, (dispatch, _arg) => {
        dispatch(Msg.ClosePopup);
    }, extraStyle, dispatch_1, model));
}

/**
 * Popup to track progress of some long operation. Progress is captured via two dialog integers, current and max number.
 * Typically the number is number of steps.
 * The popup display is controlled by model.PopupDialog integers. Progress model updates must change these.
 */
export function dynamicProgressPopupFunc(title, cancel) {
    return (dispatch_3) => ((model_2) => buildPopup(title, (dispatch, model) => {
        const dialog = model.PopupDialogData;
        const n = defaultArg(dialog.Int, 0) | 0;
        return progress(ofArray([new Option_2(/* Color */ 1, [Color_IColor.IsSuccess]), new Option_2(/* Value */ 3, [n]), new Option_2(/* Max */ 4, [~~toInt32(defaultArg(dialog.Int2, fromInt32(100)))])]), singleton_1(`${n}`));
    }, (dispatch_1, model_1) => level(singleton_1(new Level_Option(/* Props */ 0, [singleton_1(["style", {
        width: "100%",
    }])])), ofArray([left(empty(), empty()), right(empty(), singleton_1(item(empty(), singleton_1(button(ofArray([new Option_3(/* Color */ 0, [Color_IColor.IsLight]), new Option_3(/* OnClick */ 18, [(_arg) => {
        cancel(dispatch_1);
        dispatch_1(Msg.ClosePopup);
    }])]), singleton_1("Cancel"))))))])), (dispatch_2, _arg_1) => {
        dispatch_2(Msg.ClosePopup);
    }, empty(), dispatch_3, model_2));
}

/**
 * Create a popup and add it to the page. Body and foot are static content.
 * Can be closed by the ClosePopup message.
 */
export function closablePopup(title, body, foot, extraStyle, dispatch) {
    dynamicClosablePopup(title, (_arg) => body, (_arg_1) => foot, extraStyle, dispatch);
}

/**
 * As closablePopup but accept functions and return the popup function
 * Can be closed by the ClosePopup message.
 */
export function closablePopupFunc(title, body, foot, extraStyle) {
    return dynamicClosablePopupFunc(title, (dispatch, _arg) => body(dispatch), (dispatch_1, _arg_1) => foot(dispatch_1), extraStyle);
}

/**
 * Create the body of a dialog Popup with only text.
 */
export function dialogPopupBodyOnlyText(before, placeholder, dispatch, model) {
    let props;
    const dialogData = model.PopupDialogData;
    let goodLabel;
    const s = getText(dialogData);
    goodLabel = (StringModule_StartsWithLetter(s) ? true : (s === ""));
    const children_2 = [before(dialogData), input(ofArray([new Option_4(/* Type */ 1, [IInputType.Text$]), new Option_4(/* Props */ 15, [ofArray([new HTMLAttr(/* AutoFocus */ 55, [true]), new HTMLAttr(/* SpellCheck */ 148, [false])])]), new Option_4(/* Placeholder */ 12, [placeholder]), new Option_4(/* OnChange */ 13, [(arg_2) => {
        dispatch(new Msg(/* SetPopupDialogText */ 52, [getTextEventValue(arg_2)]));
    }])])), (props = [["style", {
        fontStyle: "Italic",
        color: "Red",
    }], new HTMLAttr(/* Hidden */ 92, [goodLabel])], react_1.createElement("span", keyValueList(props, 1), "Name must start with a letter"))];
    return react_1.createElement("div", {}, ...children_2);
}

/**
 * Create the body of a dialog Popup with only text for sheet description (can have an initial value + allow empty).
 */
export function dialogPopupBodyOnlyTextWithDefaultValue(before, placeholder, currDescr, dispatch, model) {
    const defaultValue = defaultArg(currDescr, "");
    const children = [before(model.PopupDialogData), input(ofArray([new Option_4(/* Type */ 1, [IInputType.Text$]), new Option_4(/* DefaultValue */ 10, [defaultValue]), new Option_4(/* Props */ 15, [ofArray([new HTMLAttr(/* AutoFocus */ 55, [true]), new HTMLAttr(/* SpellCheck */ 148, [false])])]), new Option_4(/* Placeholder */ 12, [placeholder]), new Option_4(/* OnChange */ 13, [(arg_2) => {
        dispatch(new Msg(/* SetPopupDialogText */ 52, [getTextEventValue(arg_2)]));
    }])]))];
    return react_1.createElement("div", {}, ...children);
}

/**
 * Create the body of a Verilog Editor Popup.
 */
export function dialogVerilogCompBody(before, moduleName, errorDiv, errorList, showExtraErrors, codeToAdd, compileButton, addButton, dispatch, model) {
    let props_3, props_23, children_15, props_5, props_17, children_11, children_9, props_21, children_13, props_25, props_27, props_29, children_21;
    const dialogData = model.PopupDialogData;
    const code = getCode(dialogData);
    const linesNo = ((code === "") ? ((codeToAdd != null) ? StringModule_Length(filter((ch) => (ch === "\n"), codeToAdd)) : StringModule_Length(filter((ch_1) => (ch_1 === "\n"), code))) : StringModule_Length(filter((ch_1) => (ch_1 === "\n"), code))) | 0;
    let goodLabel;
    const s = defaultArg(moduleName, "");
    goodLabel = (StringModule_StartsWithLetter(s) ? true : (s === ""));
    let renderCERSC;
    const props = new CERSCProps(code, codeToAdd, dispatch, dialogData, compileButton);
    renderCERSC = ((children) => react_1.createElement(CodeEditorReactStatefulComponent, props, ...children));
    const patternInput = showExtraErrors ? ["56%", "38%", false] : ["96%", "0%", true];
    const hide = patternInput[2];
    const i = (window.innerHeight) | 0;
    const editorheigth = int32ToString(~~(i / 2.9)) + "px";
    const tableHeigth = int32ToString(~~(i / 1.9)) + "px";
    const props_31 = [["style", {
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: FlexDirection_Option.Row,
        justifyContent: "flex-start",
    }]];
    const children_23 = [(props_3 = [["style", {
        flex: "2%",
        height: "100%",
    }]], react_1.createElement("div", keyValueList(props_3, 1))), (props_23 = [["style", {
        flex: patternInput[0],
        height: "100%",
    }]], (children_15 = [before(dialogData), input(ofArray([new Option_4(/* Type */ 1, [IInputType.Text$]), new Option_4(/* Props */ 15, [ofArray([new HTMLAttr(/* AutoFocus */ 55, [true]), new HTMLAttr(/* SpellCheck */ 148, [false])])]), new Option_4(/* Placeholder */ 12, ["Component name (equal to module name)"]), new Option_4(/* Value */ 8, [defaultArg(moduleName, "")]), new Option_4(/* Disabled */ 4, [true]), new Option_4(/* OnChange */ 13, [(arg_2) => {
        dispatch(new Msg(/* SetPopupDialogText */ 52, [getTextEventValue(arg_2)]));
    }])])), (props_5 = [["style", {
        fontStyle: "Italic",
        color: "Red",
    }], new HTMLAttr(/* Hidden */ 92, [goodLabel])], react_1.createElement("span", keyValueList(props_5, 1), "Name must start with a letter")), react_1.createElement("br", {}), react_1.createElement("br", {}), react_1.createElement("br", {}), (props_17 = [["style", {
        position: "relative",
    }]], (children_11 = [(children_9 = [react_1.createElement("b", {}, "Verilog Code:")], react_1.createElement("p", {}, ...children_9)), infoHoverableElement], react_1.createElement("div", keyValueList(props_17, 1), ...children_11))), react_1.createElement("br", {}), (props_21 = [["style", {
        position: "relative",
        minHeight: "0px",
        maxHeight: editorheigth,
        fontFamily: "ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace",
        fontSize: 16,
        backgroundColor: "#f5f5f5",
        outlineStyle: "solid",
        outlineColor: "Blue",
        overflowY: "auto",
        overflowX: "hidden",
    }]], (children_13 = [getLineCounterDiv(linesNo), errorDiv, renderCERSC(empty_1())], react_1.createElement("div", keyValueList(props_21, 1), ...children_13)))], react_1.createElement("div", keyValueList(props_23, 1), ...children_15))), (props_25 = [["style", {
        flex: "2%",
    }]], react_1.createElement("div", keyValueList(props_25, 1))), (props_27 = [["style", {
        flex: "2%",
    }], new HTMLAttr(/* Hidden */ 92, [hide])], react_1.createElement("div", keyValueList(props_27, 1))), (props_29 = [["style", {
        position: "relative",
        flex: patternInput[1],
        minHeight: "0px",
        maxHeight: tableHeigth,
        overflowY: "auto",
        overflowX: "hidden",
    }], new HTMLAttr(/* Hidden */ 92, [hide])], (children_21 = [getErrorTable(errorList, curry2(addButton)(dialogData))], react_1.createElement("div", keyValueList(props_29, 1), ...children_21)))];
    return react_1.createElement("div", keyValueList(props_31, 1), ...children_23);
}

/**
 * Create the body of a dialog Popup with only an int.
 */
export function dialogPopupBodyOnlyInt(beforeInt, intDefault, dispatch) {
    dispatch(new Msg(/* SetPopupDialogInt */ 57, [intDefault]));
    return (model) => {
        const children = [beforeInt(model.PopupDialogData), react_1.createElement("br", {}), input(ofArray([new Option_4(/* Type */ 1, [IInputType.Number$]), new Option_4(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e) => {
            preventDefault(e);
        }]), ["style", {
            width: "60px",
        }], new HTMLAttr(/* AutoFocus */ 55, [true])])]), new Option_4(/* DefaultValue */ 10, [toText(printf("%d"))(intDefault)]), new Option_4(/* OnChange */ 13, [(arg_3) => {
            dispatch(new Msg(/* SetPopupDialogInt */ 57, [getIntEventValue(arg_3)]));
        }])]))];
        return react_1.createElement("div", {}, ...children);
    };
}

/**
 * Create the body of a dialog Popup with only an int whose value is bounded
 */
export function dialogPopupBodyOnlyBoundedInt(beforeInt, intDefault, minBound, maxBound, dispatch) {
    dispatch(new Msg(/* SetPopupDialogInt */ 57, [intDefault]));
    return (model) => {
        let option_1, i, props_2;
        const errText = defaultArg((option_1 = model.PopupDialogData.Int, (option_1 != null) ? ((i = (option_1 | 0), ((i < minBound) ? true : (i > maxBound)) ? toText(`Must have between ${minBound} and ${maxBound} outputs`) : "")) : undefined), "");
        const children_2 = [beforeInt(model.PopupDialogData), react_1.createElement("br", {}), (props_2 = [["style", {
            color: HighLightColor.Red,
        }]], react_1.createElement("span", keyValueList(props_2, 1), errText)), react_1.createElement("br", {}), input(ofArray([new Option_4(/* Type */ 1, [IInputType.Number$]), new Option_4(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e) => {
            preventDefault(e);
        }]), ["style", {
            width: "60px",
        }], new HTMLAttr(/* AutoFocus */ 55, [true])])]), new Option_4(/* DefaultValue */ 10, [toText(printf("%d"))(intDefault)]), new Option_4(/* OnChange */ 13, [(arg_3) => {
            dispatch(new Msg(/* SetPopupDialogInt */ 57, [getIntEventValue(arg_3)]));
        }])]))];
        return react_1.createElement("div", {}, ...children_2);
    };
}

/**
 * `widthBoxFor` and `lsbBoxFor` draw one output's two boxes, given its index and the default the
 * lists below have worked out for it. They are passed in because they are parameter-capable boxes,
 * which this file is compiled too early to build - as for dialogPopupBodyMemorySetup.
 */
export function dialogPopupBodyNInts(beforeInt, numOutputsDefault, intDefault, maxNumOutputs, widthBoxFor, lsbBoxFor, dispatch) {
    dispatch(new Msg(/* SetPopupDialogInt */ 57, [numOutputsDefault]));
    dispatch(new Msg(/* SetPopupDialogIntList */ 61, [toList(delay(() => collect((matchValue) => singleton(intDefault), rangeDouble(1, 1, numOutputsDefault))))]));
    dispatch(new Msg(/* SetPopupDialogIntList2 */ 62, [toList(delay(() => map((x) => ((x - 1) | 0), rangeDouble(1, 1, numOutputsDefault))))]));
    return (model) => {
        let option_1, i, props_2, props_16, children_4, props_14, children_10;
        const dialogData = model.PopupDialogData;
        const errText = defaultArg((option_1 = model.PopupDialogData.Int, (option_1 != null) ? ((i = (option_1 | 0), ((i < 2) ? true : (i > maxNumOutputs)) ? toText(`Must have between 2 and ${maxNumOutputs} outputs`) : "")) : undefined), "");
        let newInt;
        const matchValue_1 = getInt(dialogData) | 0;
        if (matchValue_1 < 2) {
            const matchValue_2 = dialogData.IntList;
            newInt = ((matchValue_2 != null) ? length(matchValue_2) : numOutputsDefault);
        }
        else {
            newInt = matchValue_1;
        }
        let setupWidthList;
        const matchValue_3 = dialogData.IntList;
        if (matchValue_3 != null) {
            const outputWidthList = matchValue_3;
            const newNumInputs = newInt | 0;
            const matchValue_4 = length(outputWidthList) | 0;
            setupWidthList = ((matchValue_4 > newNumInputs) ? getSlice(undefined, newNumInputs - 1, outputWidthList) : ((matchValue_4 < newNumInputs) ? append(outputWidthList, initialize(newNumInputs - matchValue_4, (_arg) => 1)) : outputWidthList));
        }
        else {
            const setup = getIntList(dialogData, numOutputsDefault, intDefault);
            dispatch(new Msg(/* SetPopupDialogIntList */ 61, [setup]));
            setupWidthList = setup;
        }
        let setupLSBList;
        const matchValue_5 = dialogData.IntList2;
        if (matchValue_5 != null) {
            const lsbList = matchValue_5;
            const newNumInputs_1 = newInt | 0;
            const matchValue_6 = length(lsbList) | 0;
            if (matchValue_6 > newNumInputs_1) {
                setupLSBList = getSlice(undefined, newNumInputs_1 - 1, lsbList);
            }
            else if (matchValue_6 < newNumInputs_1) {
                const matchValue_7 = dialogData.IntList;
                if (matchValue_7 != null) {
                    const msbs = map2((lsb, width) => (((lsb + width) - 1) | 0), lsbList, matchValue_7);
                    setupLSBList = append(lsbList, initialize(newNumInputs_1 - matchValue_6, (x_1) => (((x_1 + max(msbs, {
                        Compare: (x_2, y) => (comparePrimitives(x_2, y) | 0),
                    })) + 1) | 0)));
                }
                else {
                    throw new Exception("No width list in dialogData");
                }
            }
            else {
                setupLSBList = lsbList;
            }
        }
        else {
            const setup_1 = getIntList2(dialogData, numOutputsDefault, 0);
            dispatch(new Msg(/* SetPopupDialogIntList2 */ 62, [setup_1]));
            setupLSBList = setup_1;
        }
        if (!equals(dialogData.IntList, setupWidthList)) {
            dispatch(new Msg(/* SetPopupDialogIntList */ 61, [setupWidthList]));
        }
        if (!equals(dialogData.IntList2, setupLSBList)) {
            dispatch(new Msg(/* SetPopupDialogIntList2 */ 62, [setupLSBList]));
        }
        const children_13 = [beforeInt(dialogData), react_1.createElement("br", {}), (props_2 = [["style", {
            color: HighLightColor.Red,
        }]], react_1.createElement("span", keyValueList(props_2, 1), errText)), react_1.createElement("br", {}), input(ofArray([new Option_4(/* Type */ 1, [IInputType.Number$]), new Option_4(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e) => {
            preventDefault(e);
        }]), ["style", {
            width: "60px",
        }], new HTMLAttr(/* AutoFocus */ 55, [true])])]), new Option_4(/* DefaultValue */ 10, [toText(printf("%d"))(numOutputsDefault)]), new Option_4(/* OnChange */ 13, [(arg_3) => {
            dispatch(new Msg(/* SetPopupDialogInt */ 57, [getIntEventValue(arg_3)]));
        }])])), react_1.createElement("br", {}), react_1.createElement("br", {}), "What is the width and least significant bit (LSB) number of each output?", react_1.createElement("br", {}), react_1.createElement("br", {}), (props_16 = [["style", {
            display: "flex",
        }]], (children_4 = [(props_14 = [["style", {
            width: "115px",
        }]], react_1.createElement("div", keyValueList(props_14, 1))), label(singleton_1(new Option_5(/* Props */ 3, [singleton_1(["style", {
            width: "200px",
        }])])), singleton_1("Width")), label(singleton_1(new Option_5(/* Props */ 3, [singleton_1(["style", {
            width: "200px",
        }])])), singleton_1("LSB"))], react_1.createElement("div", keyValueList(props_16, 1), ...children_4))), (children_10 = mapIndexed2((index, defaultWidthValue, defaultLSBValue) => {
            let props_18, children_6;
            const props_20 = [["style", {
                display: "flex",
                alignItems: "flex-start",
            }]];
            const children_8 = [(props_18 = [["style", {
                width: "105px",
                marginRight: "10px",
                marginTop: "6px",
            }]], (children_6 = [toText(printf("Output Port %d:"))(index)], react_1.createElement("label", keyValueList(props_18, 1), ...children_6))), widthBoxFor(index, defaultWidthValue, model), lsbBoxFor(index, defaultLSBValue, model)];
            return react_1.createElement("div", keyValueList(props_20, 1), ...children_8);
        }, setupWidthList, setupLSBList), react_1.createElement("div", {}, ...children_10)), react_1.createElement("br", {}), react_1.createElement("br", {})];
        return react_1.createElement("div", {}, ...children_13);
    };
}

/**
 * Create the body of a dialog Popup with two ints.
 */
export function dialogPopupBodyTwoInts(beforeInt1, beforeInt2, intDefault1, intDefault2, width2, dispatch) {
    const setPopupTwoInts = (tupledArg, n) => {
        dispatch(new Msg(/* SetPopupDialogTwoInts */ 60, [[n, tupledArg[0], tupledArg[1]]]));
    };
    setPopupTwoInts([IntMode.FirstInt, undefined], intDefault1);
    setPopupTwoInts([IntMode.SecondInt, undefined], intDefault2);
    return (model) => {
        let f2_1;
        const dialogData = model.PopupDialogData;
        const children = [beforeInt1(dialogData), react_1.createElement("br", {}), input(ofArray([new Option_4(/* Type */ 1, [IInputType.Number$]), new Option_4(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e) => {
            preventDefault(e);
        }]), ["style", {
            width: "60px",
        }], new HTMLAttr(/* AutoFocus */ 55, [true])])]), new Option_4(/* DefaultValue */ 10, [toText(printf("%A"))(intDefault1)]), new Option_4(/* OnChange */ 13, [(f2_1 = curry2(setPopupTwoInts)([IntMode.FirstInt, undefined]), (arg_2) => {
            f2_1(fromInt32(getIntEventValue(arg_2)));
        })])])), react_1.createElement("br", {}), beforeInt2(dialogData), react_1.createElement("br", {}), input(ofArray([new Option_4(/* Type */ 1, [IInputType.Text$]), new Option_4(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e_1) => {
            preventDefault(e_1);
        }]), ["style", {
            width: width2,
        }], new HTMLAttr(/* AutoFocus */ 55, [true])])]), new Option_4(/* DefaultValue */ 10, [toText(printf("%A"))(intDefault2)]), new Option_4(/* OnChange */ 13, [(ev) => {
            setPopupTwoInts([IntMode.SecondInt, getTextEventValue(ev)], getBigintEventValue(ev));
        }])]))];
        return react_1.createElement("div", {}, ...children);
    };
}

/**
 * Create the body of a dialog Popup with text and two ints.
 * focus: which of the boxes has initial focus (= 1,2,3)
 */
export function dialogPopupBodyTextAndTwoInts(focus, beforeText, textPlaceholder, beforeInt1, beforeInt2, intDefault1, intDefault2, dispatch) {
    const setPopupTwoInts = (tupledArg, n) => {
        dispatch(new Msg(/* SetPopupDialogTwoInts */ 60, [[n, tupledArg[0], tupledArg[1]]]));
    };
    setPopupTwoInts([IntMode.FirstInt, undefined], intDefault1);
    setPopupTwoInts([IntMode.SecondInt, undefined], intDefault2);
    return (model) => {
        let f2_4;
        const dialogData = model.PopupDialogData;
        const children = [beforeText(dialogData), react_1.createElement("br", {}), input(ofArray([new Option_4(/* Type */ 1, [IInputType.Text$]), new Option_4(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e) => {
            preventDefault(e);
        }]), new HTMLAttr(/* AutoFocus */ 55, [focus === 1]), new HTMLAttr(/* SpellCheck */ 148, [false])])]), new Option_4(/* Placeholder */ 12, [textPlaceholder]), new Option_4(/* OnChange */ 13, [(arg_2) => {
            dispatch(new Msg(/* SetPopupDialogText */ 52, [getTextEventValue(arg_2)]));
        }])])), beforeInt1(dialogData), react_1.createElement("br", {}), input(ofArray([new Option_4(/* Type */ 1, [IInputType.Number$]), new Option_4(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e_1) => {
            preventDefault(e_1);
        }]), ["style", {
            width: "60px",
        }], new HTMLAttr(/* AutoFocus */ 55, [focus === 2])])]), new Option_4(/* DefaultValue */ 10, [toText(printf("%A"))(intDefault1)]), new Option_4(/* OnChange */ 13, [(f2_4 = curry2(setPopupTwoInts)([IntMode.FirstInt, undefined]), (arg_5) => {
            f2_4(fromInt32(getIntEventValue(arg_5)));
        })])])), react_1.createElement("br", {}), beforeInt2(dialogData), react_1.createElement("br", {}), input(ofArray([new Option_4(/* Type */ 1, [IInputType.Text$]), new Option_4(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e_2) => {
            preventDefault(e_2);
        }]), ["style", {
            width: "60px",
        }], new HTMLAttr(/* AutoFocus */ 55, [focus === 3])])]), new Option_4(/* DefaultValue */ 10, [toText(printf("%A"))(intDefault2)]), new Option_4(/* OnChange */ 13, [(ev) => {
            setPopupTwoInts([IntMode.SecondInt, getTextEventValue(ev)], getBigintEventValue(ev));
        }])]))];
        return react_1.createElement("div", {}, ...children);
    };
}

/**
 * Create the body of a dialog Popup with two text fields, both required.
 * First goes to Text, second to Text2.
 */
export function dialogPopupBodyTwoTexts(beforeText1, placeholder1, beforeText2, placeholder2, dispatch, model) {
    const dialogData = model.PopupDialogData;
    const children = [beforeText1(dialogData), input(ofArray([new Option_4(/* Type */ 1, [IInputType.Text$]), new Option_4(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e) => {
        preventDefault(e);
    }]), new HTMLAttr(/* AutoFocus */ 55, [true]), new HTMLAttr(/* SpellCheck */ 148, [false])])]), new Option_4(/* Placeholder */ 12, [placeholder1]), new Option_4(/* OnChange */ 13, [(arg_2) => {
        dispatch(new Msg(/* SetPopupDialogText */ 52, [getTextEventValue(arg_2)]));
    }])])), react_1.createElement("br", {}), react_1.createElement("br", {}), beforeText2(dialogData), input(ofArray([new Option_4(/* Type */ 1, [IInputType.Text$]), new Option_4(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e_1) => {
        preventDefault(e_1);
    }]), new HTMLAttr(/* SpellCheck */ 148, [true])])]), new Option_4(/* Placeholder */ 12, [placeholder2]), new Option_4(/* OnChange */ 13, [(arg_5) => {
        dispatch(new Msg(/* SetPopupDialogText2 */ 53, [getTextEventValue(arg_5)]));
    }])]))];
    return react_1.createElement("div", {}, ...children);
}

/**
 * Create the body of a dialog Popup with both text and int.
 */
export function dialogPopupBodyTextAndInt(beforeText, placeholder, beforeInt, intDefault, dispatch) {
    dispatch(new Msg(/* SetPopupDialogInt */ 57, [intDefault]));
    return (model) => {
        let props, props_2;
        const dialogData = model.PopupDialogData;
        let goodLabelStart;
        const s = getText(dialogData);
        goodLabelStart = (StringModule_StartsWithLetter(s) ? true : (s === ""));
        let goodLabelLetters;
        const s_1 = getText(dialogData);
        goodLabelLetters = (isMatch(/^[a-zA-Z0-9]+$/gu, s_1) ? true : (s_1 === ""));
        const children_4 = [beforeText(dialogData), input(ofArray([new Option_4(/* Type */ 1, [IInputType.Text$]), new Option_4(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e) => {
            preventDefault(e);
        }]), new HTMLAttr(/* AutoFocus */ 55, [true]), new HTMLAttr(/* SpellCheck */ 148, [false])])]), new Option_4(/* Placeholder */ 12, [placeholder]), new Option_4(/* OnChange */ 13, [(arg_2) => {
            dispatch(new Msg(/* SetPopupDialogText */ 52, [getTextEventValue(arg_2)]));
        }])])), (props = [["style", {
            fontStyle: "Italic",
            color: "Red",
        }], new HTMLAttr(/* Hidden */ 92, [goodLabelStart])], react_1.createElement("span", keyValueList(props, 1), "Name must start with a letter.")), (props_2 = [["style", {
            fontStyle: "Italic",
            color: "Red",
        }], new HTMLAttr(/* Hidden */ 92, [goodLabelLetters ? true : !goodLabelStart])], react_1.createElement("span", keyValueList(props_2, 1), "Name can only contain letters and numbers.")), react_1.createElement("br", {}), react_1.createElement("br", {}), beforeInt(dialogData), react_1.createElement("br", {}), input(ofArray([new Option_4(/* Type */ 1, [IInputType.Number$]), new Option_4(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e_1) => {
            preventDefault(e_1);
        }]), ["style", {
            width: "60px",
        }]])]), new Option_4(/* DefaultValue */ 10, [toText(printf("%d"))(intDefault)]), new Option_4(/* OnChange */ 13, [(arg_6) => {
            dispatch(new Msg(/* SetPopupDialogInt */ 57, [getIntEventValue(arg_6)]));
        }])]))];
        return react_1.createElement("div", {}, ...children_4);
    };
}

/**
 * A parameter's value, typed into a box.
 * 
 * A text box parsed as a bigint rather than an Input.number, because a parameter value is a
 * ParamInt and so may be larger than any int: a parameter that gives a wide Constant its value is
 * the case that needs it. The box is uncontrolled, so an unparseable entry stays on screen to be
 * corrected while Int2 goes to None, which is what the red text and the disabled button read.
 */
export function paramValueBox(valueDefault, dispatch) {
    return input(ofArray([new Option_4(/* Type */ 1, [IInputType.Text$]), new Option_4(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e) => {
        preventDefault(e);
    }]), new HTMLAttr(/* SpellCheck */ 148, [false]), ["style", {
        width: "120px",
    }]])]), new Option_4(/* DefaultValue */ 10, [toString(valueDefault)]), new Option_4(/* OnChange */ 13, [(arg) => {
        let matchValue, outArg;
        dispatch(new Msg(/* SetPopupDialogInt2 */ 58, [(matchValue = ((outArg = (0n), [tryParse(getTextEventValue(arg), new FSharpRef(() => outArg, (v) => {
            outArg = v;
        })), outArg])), matchValue[0] ? matchValue[1] : undefined)]));
    }])]));
}

/**
 * The red text under a parameter's value box: shown only once the box has been made unparseable,
 * since it opens holding a value that parses.
 */
export function paramValueError(dialogData) {
    const props = [["style", {
        fontStyle: "Italic",
        color: "Red",
    }], new HTMLAttr(/* Hidden */ 92, [dialogData.Int2 != null])];
    return react_1.createElement("span", keyValueList(props, 1), "A property\'s value is a whole number.");
}

/**
 * Create the body of a dialog Popup with a name, a compulsory description, and a value.
 * Used to declare a sheet parameter: the description is what a custom component instance of the
 * sheet shows the user when it asks them for a value, so a parameter cannot be declared without
 * one. Name goes to Text, description to Text2, value to Int2.
 * 
 * `nameIsTaken` is asked whether the sheet already declares a parameter of that name. Passed in
 * rather than worked out here, so that this file needs to know nothing about where a sheet keeps
 * its parameters.
 */
export function dialogPopupBodyTextDescriptionAndInt(beforeText, placeholder, beforeDescription, descriptionPlaceholder, beforeInt, intDefault, nameIsTaken, dispatch) {
    dispatch(new Msg(/* SetPopupDialogInt2 */ 58, [intDefault]));
    return (model) => {
        let props, props_2, props_4, children_4, props_6, children_6, props_12;
        const dialogData = model.PopupDialogData;
        const name = getText(dialogData);
        const goodLabelStart = StringModule_StartsWithLetter(name) ? true : (name === "");
        const goodLabelLetters = isValidParamName(name) ? true : (name === "");
        const reserved = isReservedParamName(name);
        const taken = (name !== "") && nameIsTaken(name);
        const describedOrUnstarted = (getText2(dialogData) !== "") ? true : (name === "");
        const children_10 = [beforeText(dialogData), input(ofArray([new Option_4(/* Type */ 1, [IInputType.Text$]), new Option_4(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e) => {
            preventDefault(e);
        }]), new HTMLAttr(/* AutoFocus */ 55, [true]), new HTMLAttr(/* SpellCheck */ 148, [false])])]), new Option_4(/* Placeholder */ 12, [placeholder]), new Option_4(/* OnChange */ 13, [(arg_2) => {
            dispatch(new Msg(/* SetPopupDialogText */ 52, [getTextEventValue(arg_2)]));
        }])])), (props = [["style", {
            fontStyle: "Italic",
            color: "Red",
        }], new HTMLAttr(/* Hidden */ 92, [goodLabelStart])], react_1.createElement("span", keyValueList(props, 1), "Name must start with a letter.")), (props_2 = [["style", {
            fontStyle: "Italic",
            color: "Red",
        }], new HTMLAttr(/* Hidden */ 92, [(goodLabelLetters ? true : reserved) ? true : !goodLabelStart])], react_1.createElement("span", keyValueList(props_2, 1), "Name can only contain letters and numbers.")), (props_4 = [["style", {
            fontStyle: "Italic",
            color: "Red",
        }], new HTMLAttr(/* Hidden */ 92, [!reserved])], (children_4 = [concat(name, " is a built-in function, so cannot be a property name.")], react_1.createElement("span", keyValueList(props_4, 1), ...children_4))), (props_6 = [["style", {
            fontStyle: "Italic",
            color: "Red",
        }], new HTMLAttr(/* Hidden */ 92, [!taken])], (children_6 = [concat("This sheet already has a property called ", name, ". Edit that one to change its value.")], react_1.createElement("span", keyValueList(props_6, 1), ...children_6))), react_1.createElement("br", {}), react_1.createElement("br", {}), beforeDescription(dialogData), input(ofArray([new Option_4(/* Type */ 1, [IInputType.Text$]), new Option_4(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e_1) => {
            preventDefault(e_1);
        }]), new HTMLAttr(/* SpellCheck */ 148, [true])])]), new Option_4(/* Placeholder */ 12, [descriptionPlaceholder]), new Option_4(/* OnChange */ 13, [(arg_5) => {
            dispatch(new Msg(/* SetPopupDialogText2 */ 53, [getTextEventValue(arg_5)]));
        }])])), (props_12 = [["style", {
            fontStyle: "Italic",
            color: "Red",
        }], new HTMLAttr(/* Hidden */ 92, [describedOrUnstarted])], react_1.createElement("span", keyValueList(props_12, 1), "A description is required: it is what users of this sheet read when asked for a value.")), react_1.createElement("br", {}), react_1.createElement("br", {}), beforeInt(dialogData), react_1.createElement("br", {}), paramValueBox(intDefault, dispatch), paramValueError(dialogData)];
        return react_1.createElement("div", {}, ...children_10);
    };
}

/**
 * Create the body of a dialog Popup with a compulsory description and a value, for editing an
 * existing sheet parameter whose name is fixed. The caller seeds Text2 with the current
 * description so that editing only the value leaves it intact.
 * 
 * `valueProblem` is asked what is wrong with the value now in the box, and its answer is shown.
 * The OK button is disabled when a slot of the sheet would break at the new value, and used to be
 * disabled in silence - leaving the user to guess which component objected and why, when the
 * constraint that failed carries a sentence written to explain exactly that.
 */
export function dialogPopupBodyDescriptionAndInt(beforeDescription, currentDescription, beforeInt, intDefault, valueProblem, dispatch) {
    dispatch(new Msg(/* SetPopupDialogInt2 */ 58, [intDefault]));
    return (model) => {
        let props, props_8;
        const dialogData = model.PopupDialogData;
        const problem = defaultArg(valueProblem(model), "");
        const children_4 = [beforeDescription(dialogData), input(ofArray([new Option_4(/* Type */ 1, [IInputType.Text$]), new Option_4(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e) => {
            preventDefault(e);
        }]), new HTMLAttr(/* AutoFocus */ 55, [true]), new HTMLAttr(/* SpellCheck */ 148, [true])])]), new Option_4(/* DefaultValue */ 10, [currentDescription]), new Option_4(/* OnChange */ 13, [(arg_2) => {
            dispatch(new Msg(/* SetPopupDialogText2 */ 53, [getTextEventValue(arg_2)]));
        }])])), (props = [["style", {
            fontStyle: "Italic",
            color: "Red",
        }], new HTMLAttr(/* Hidden */ 92, [getText2(dialogData) !== ""])], react_1.createElement("span", keyValueList(props, 1), "A description is required: it is what users of this sheet read when asked for a value.")), react_1.createElement("br", {}), react_1.createElement("br", {}), beforeInt(dialogData), react_1.createElement("br", {}), paramValueBox(intDefault, dispatch), paramValueError(dialogData), (props_8 = [["style", {
            color: "Red",
        }]], react_1.createElement("p", keyValueList(props_8, 1), problem))];
        return react_1.createElement("div", {}, ...children_4);
    };
}

/**
 * Create the body of a dialog Popup with both text and int.
 */
export function dialogPopupBodyIntAndText(beforeText, placeholder, beforeInt, intDefault, dispatch) {
    dispatch(new Msg(/* SetPopupDialogInt */ 57, [intDefault]));
    return (model) => {
        const children = [beforeInt(model.PopupDialogData), react_1.createElement("br", {}), input(ofArray([new Option_4(/* Type */ 1, [IInputType.Number$]), new Option_4(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e) => {
            preventDefault(e);
        }]), ["style", {
            width: "60px",
        }]])]), new Option_4(/* DefaultValue */ 10, [toText(printf("%d"))(intDefault)]), new Option_4(/* OnChange */ 13, [(arg_3) => {
            dispatch(new Msg(/* SetPopupDialogInt */ 57, [getIntEventValue(arg_3)]));
        }])])), react_1.createElement("br", {}), react_1.createElement("br", {}), beforeText(model), input(ofArray([new Option_4(/* Type */ 1, [IInputType.Text$]), new Option_4(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e_1) => {
            preventDefault(e_1);
        }]), new HTMLAttr(/* AutoFocus */ 55, [true]), new HTMLAttr(/* SpellCheck */ 148, [false])])]), new Option_4(/* Placeholder */ 12, [placeholder]), new Option_4(/* OnChange */ 13, [(arg_6) => {
            dispatch(new Msg(/* SetPopupDialogText */ 52, [getTextEventValue(arg_6)]));
        }])]))];
        return react_1.createElement("div", {}, ...children);
    };
}

/**
 * Create the body of a memory dialog popup: asks for AddressWidth and
 * WordWidth, two integers.
 * `addressBox` and `wordBox` draw the two widths, and `widthsOf` reads what they hold.
 * 
 * They are passed in rather than drawn here because they are parameter-capable boxes - the same
 * box the Properties pane uses, so that a memory's widths can be set from a property as it is
 * placed - and the parameter code is compiled long after this file. What is left here is the rest
 * of the dialog: where the data comes from, and the rules relating that to the address width.
 */
export function dialogPopupBodyMemorySetup(intDefault, addressBox, wordBox, widthsOf, dispatch, model) {
    const dialogData = model.PopupDialogData;
    let setup_1;
    const matchValue = dialogData.MemorySetup;
    if (matchValue != null) {
        matchValue[3];
        matchValue[2];
        setup_1 = [matchValue[0], matchValue[1], InitMemData.FromData, undefined];
    }
    else {
        const setup = getMemorySetup(dialogData, intDefault);
        dispatch(new Msg(/* SetPopupDialogMemorySetup */ 68, [setup]));
        setup_1 = setup;
    }
    let setup_2;
    const matchValue_1 = widthsOf(dialogData);
    setup_2 = ((matchValue_1 == null) ? setup_1 : [matchValue_1[0], matchValue_1[1], setup_1[2], setup_1[3]]);
    if (!equals(dialogData.MemorySetup, setup_2)) {
        dispatch(new Msg(/* SetPopupDialogMemorySetup */ 68, [setup_2]));
    }
    const source_1 = setup_2[2];
    const addressWidth = setup_2[0] | 0;
    const dataSetupMess = (source_1.tag === 0) ? "You will be able to set up memory content later from the component Properties menu" : ((source_1.tag === 1) ? concat("Memory content is fixed by the \'", source_1.fields[0], ".ram\' file in the project directory") : ((source_1.tag === 2) ? concat("You will be able to set up memory content later from the component Properties menu, it will be written to the \'", source_1.fields[0], ".ram file in the project directory") : ((source_1.tag === 3) ? "" : "Memory initial data is determined by the requested multiplication")));
    const children_2 = toList(delay(() => append_1(singleton(addressBox(model)), delay(() => {
        let arg_1;
        return append_1(singleton((arg_1 = op_LeftShift(fromOne(), addressWidth), toText(printf("%d bits yield %A memory locations."))(addressWidth)(arg_1))), delay(() => append_1(singleton(react_1.createElement("br", {})), delay(() => append_1(singleton(react_1.createElement("br", {})), delay(() => append_1(singleton(wordBox(model)), delay(() => append_1(singleton(react_1.createElement("br", {})), delay(() => append_1(singleton(dataSetupMess), delay(() => append_1(singleton(react_1.createElement("br", {})), delay(() => {
            let props_8;
            const matchValue_2 = setup_2[3];
            if (matchValue_2 != null) {
                const msg = matchValue_2;
                return singleton((props_8 = [["style", {
                    color: "red",
                }]], react_1.createElement("div", keyValueList(props_8, 1), msg)));
            }
            else {
                return singleton(react_1.createElement("br", {}));
            }
        }))))))))))))));
    }))));
    return react_1.createElement("div", {}, ...children_2);
}

/**
 * Popup with an input textbox and two buttons.
 * The text is reflected in Model.PopupDialogText.
 * 
 * Return confirms the dialog, as it does in any other dialog with one obvious action. It used to
 * reach KeyTypes.ScLeaveTextBox, whose job is to hand the keyboard back to the schematic: inside a
 * popup that blurred the box the user had just typed into and did nothing else, which read as the
 * entry having been thrown away. Swallowed here whether or not the action is available, so that
 * Return means one thing inside a dialog rather than confirming it or emptying it depending on
 * whether what has been typed so far is valid.
 */
export function dialogPopup(title, body, buttonText, buttonAction, isDisabled, extraStyle, dispatch) {
    dynamicClosablePopup(title, (model) => {
        const children = [body(model)];
        return react_1.createElement("div", {
            onKeyDown: (ev) => {
                if (ev.key === "Enter") {
                    ev.preventDefault();
                    ev.stopPropagation();
                    if (!isDisabled(model)) {
                        buttonAction(model);
                    }
                }
            },
        }, ...children);
    }, (model_1) => level(singleton_1(new Level_Option(/* Props */ 0, [singleton_1(["style", {
        width: "100%",
    }])])), ofArray([left(empty(), empty()), right(empty(), ofArray([item(empty(), singleton_1(button(ofArray([new Option_3(/* Color */ 0, [Color_IColor.IsLight]), new Option_3(/* OnClick */ 18, [(_arg) => {
        dispatch(Msg.ClosePopup);
        dispatch(Msg.FinishUICmd);
    }])]), singleton_1("Cancel")))), item(empty(), singleton_1(button(ofArray([new Option_3(/* Disabled */ 16, [isDisabled(model_1)]), new Option_3(/* Color */ 0, [Color_IColor.IsPrimary]), new Option_3(/* OnClick */ 18, [(_arg_1) => {
        buttonAction(model_1);
    }])]), singleton_1(buttonText))))]))])), extraStyle, dispatch);
}

export function dialogPopupRefresh(title, body, extraStyle, dispatch) {
    dynamicClosablePopup(title, body, (model) => level(singleton_1(new Level_Option(/* Props */ 0, [singleton_1(["style", {
        width: "100%",
    }])])), ofArray([left(empty(), empty()), right(empty(), singleton_1(item(empty(), singleton_1(button(ofArray([new Option_3(/* Color */ 0, [Color_IColor.IsLight]), new Option_3(/* OnClick */ 18, [(_arg) => {
        dispatch(Msg.ClosePopup);
        dispatch(Msg.FinishUICmd);
    }])]), singleton_1("Cancel"))))))])), extraStyle, dispatch);
}

/**
 * Popup with an input textbox and two buttons.
 * The text is reflected in Model.PopupDialogText.
 * The Verilog editor. Unlike every other popup here it holds work that exists nowhere else until
 * it is saved, so leaving it is the one irrecoverable thing it can do.
 * 
 * `cancelAction` is therefore given all three ways out that are not Save - the Cancel button, the
 * X, and a click on the background - rather than each dispatching ClosePopup for itself. They
 * discard exactly the same edits, so a confirmation on one of them and not the others would be a
 * confirmation the user can miss by clicking somewhere else.
 */
export function dialogVerilogPopup(title, body, saveUpdateText, noErrors, showingExtraInfo, saveButtonAction, moreInfoButton, cancelAction, isDisabled, extraStyle, dispatch) {
    return dispatch(new Msg(/* ShowPopup */ 49, [(dispatch_2, model_1) => buildPopup(title, uncurry2((_arg_5) => body), (_arg_6, model) => {
        const dialogData = model.PopupDialogData;
        const compileButtonText = noErrors ? "Compiled" : (showingExtraInfo ? "Hide Info" : "More Info");
        const compileButtonColor = noErrors ? Color_IColor.IsInfo : Color_IColor.IsDanger;
        return level(singleton_1(new Level_Option(/* Props */ 0, [singleton_1(["style", {
            width: "100%",
        }])])), ofArray([left(empty(), empty()), right(empty(), ofArray([item(empty(), singleton_1(button(ofArray([new Option_3(/* Color */ 0, [Color_IColor.IsLight]), new Option_3(/* OnClick */ 18, [(_arg_2) => {
            cancelAction(dialogData);
        }])]), singleton_1("Cancel")))), item(empty(), singleton_1(button(ofArray([new Option_3(/* Disabled */ 16, [noErrors]), new Option_3(/* Color */ 0, [compileButtonColor]), new Option_3(/* OnClick */ 18, [(_arg_3) => {
            moreInfoButton(dialogData);
        }])]), singleton_1(compileButtonText)))), item(empty(), singleton_1(button(ofArray([new Option_3(/* Disabled */ 16, [isDisabled(dialogData)]), new Option_3(/* Color */ 0, [Color_IColor.IsPrimary]), new Option_3(/* OnClick */ 18, [(_arg_4) => {
            saveButtonAction(dialogData);
        }])]), singleton_1(saveUpdateText))))]))]));
    }, (dispatch_1, _arg) => {
        dispatch_1(new Msg(/* ExecFuncInMessage */ 116, [(m, _arg_1) => {
            cancelAction(m.PopupDialogData);
        }, dispatch_1]));
    }, extraStyle, dispatch_2, model_1)]));
}

export function staticButtonFoot(buttonAction, buttonText, dispatch) {
    return level(singleton_1(new Level_Option(/* Props */ 0, [singleton_1(["style", {
        width: "100%",
    }])])), ofArray([left(empty(), empty()), right(empty(), ofArray([item(empty(), singleton_1(button(ofArray([new Option_3(/* Color */ 0, [Color_IColor.IsLight]), new Option_3(/* OnClick */ 18, [(_arg) => {
        dispatch(Msg.ClosePopup);
    }])]), singleton_1("Cancel")))), item(empty(), singleton_1(button(ofArray([new Option_3(/* Color */ 0, [Color_IColor.IsPrimary]), new Option_3(/* OnClick */ 18, [buttonAction])]), singleton_1(buttonText))))]))]));
}

/**
 * A static confirmation popup.
 */
export function confirmationPopup(title, buttonText, body, buttonAction, dispatch) {
    closablePopup(title, body, staticButtonFoot((_arg) => {
        buttonAction();
    }, buttonText, dispatch), empty(), dispatch);
}

export function dynamicConfirmationPopup(title, buttonText, body, buttonActionOpt, dispatch) {
    const buttonAction = defaultArg(buttonActionOpt, () => {
        dispatch(Msg.ClosePopup);
    });
    const foot = staticButtonFoot((_arg_1) => {
        buttonAction();
    }, buttonText, dispatch);
    dynamicClosablePopup(title, body, (_arg_2) => foot, empty(), dispatch);
}

/**
 * A static choice dialog popup returning the popup function
 */
export function choicePopupFunc(title, body, buttonTrueText, buttonFalseText, buttonAction) {
    return closablePopupFunc(title, body, (dispatch) => level(singleton_1(new Level_Option(/* Props */ 0, [singleton_1(["style", {
        width: "100%",
    }])])), ofArray([left(empty(), empty()), right(empty(), ofArray([item(empty(), singleton_1(button(ofArray([new Option_3(/* Color */ 0, [Color_IColor.IsLight]), new Option_3(/* OnClick */ 18, [curry3(buttonAction)(false)(dispatch)])]), singleton_1(buttonFalseText)))), item(empty(), singleton_1(button(ofArray([new Option_3(/* Color */ 0, [Color_IColor.IsPrimary]), new Option_3(/* OnClick */ 18, [curry3(buttonAction)(true)(dispatch)])]), singleton_1(buttonTrueText))))]))])), empty());
}

/**
 * A static choice dialog popup.
 */
export function choicePopup(title, body, buttonTrueText, buttonFalseText, buttonAction, dispatch) {
    return dispatch(new Msg(/* ShowPopup */ 49, [uncurry2(choicePopupFunc(title, (_arg) => body, buttonTrueText, buttonFalseText, uncurry3((bool) => ((dispatch_1) => curry2(buttonAction)(bool)))))]));
}

/**
 * Base popup builder function, used by other popup generators: close function depends on (dynamic) model.
 * OK button is enabled based on return from body function
 */
export function newBuildPopup(title, body, foot, close, extraStyle, dispatch, model) {
    return modal(ofArray([new Option(/* IsActive */ 1, [true]), new Option(/* CustomClass */ 2, ["modal1"]), new Option(/* Props */ 0, [singleton_1(["style", {
        zIndex: 20000,
    }])])]), ofArray([background(singleton_1(new Common_GenericOption(/* Props */ 1, [singleton_1(new DOMAttr(/* OnClick */ 40, [(_arg) => {
        close(dispatch, model);
    }]))])), empty()), Card_card(singleton_1(new Common_GenericOption(/* Props */ 1, [singleton_1(["style", keyValueList(append(ofArray([new CSSProp(/* OverflowY */ 272, ["auto"]), new CSSProp(/* OverflowX */ 271, ["visible"]), new CSSProp(/* UserSelect */ 381, ["none"])]), extraStyle), 1)])])), ofArray([Card_head(empty(), ofArray([Card_title(empty(), singleton_1(title)), delete$(singleton_1(new Option_1(/* OnClick */ 3, [(_arg_1) => {
        close(dispatch, model);
    }])), empty())])), Card_body(singleton_1(new Common_GenericOption(/* Props */ 1, [singleton_1(["style", {
        overflowY: "visible",
        overflowX: "visible",
    }])])), singleton_1(body(dispatch, model))), Card_foot(empty(), singleton_1(foot(dispatch, model)))]))]));
}

export function newButtonFoot(buttonAction, buttonText, closeAction, enable, dispatch, model) {
    return level(singleton_1(new Level_Option(/* Props */ 0, [singleton_1(["style", {
        width: "100%",
    }])])), ofArray([left(empty(), empty()), right(empty(), ofArray([item(empty(), singleton_1(button(ofArray([new Option_3(/* Color */ 0, [Color_IColor.IsLight]), new Option_3(/* OnClick */ 18, [(_arg) => {
        closeAction(dispatch, model);
    }])]), singleton_1("Cancel")))), item(empty(), singleton_1(button(ofArray([new Option_3(/* Color */ 0, [Color_IColor.IsPrimary]), new Option_3(/* Disabled */ 16, [enable(model)]), new Option_3(/* OnClick */ 18, [(_arg_1) => {
        buttonAction(dispatch, model);
    }])]), singleton_1(buttonText))))]))]));
}

export function newConfirmationPopup(title, body, buttonActionOpt, buttonEnable, close, dispatch, model) {
    const buttonAction = defaultArg(map_1(curry2, buttonActionOpt), (_arg) => ((_arg_1) => {
        dispatch(Msg.ClosePopup);
    }));
    return newBuildPopup(title, body, (dispatch_1, model_1) => newButtonFoot(uncurry2(buttonAction), "Ok", close, buttonEnable, dispatch_1, model_1), close, empty(), dispatch, model);
}

